<script>
import Modal from '../../../components/Modal.vue'

export default {
    components: {
        Modal
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isSubmitted: false
        }
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle()
        },
        pass() {
            this.isSubmitted = true
            this.$emit('submit')
        }
    }
}
</script>

<template>
   <modal ref="modal" heading="ID Verification">
        <div class="mb-4">
            <h5>Are you sure? Passing the candidate will fire off the iFacts ID Verification check.</h5>
        </div>

        <div class="grid-x grid-padding-x align-right">
            <div class="cell shrink">
                <button class="button success" :disabled="isSubmitted" type="button" @click="pass">Continue</button>
            </div>
            <div class="cell shrink">
                <button class="button warning" type="button" @click="toggleModal">Close</button>
            </div>
        </div>
    </modal>
</template>